import {z} from 'zod'

import {CrossTabSchema} from './common'

export const SummaryStatsDataSchema = z
    .object({
        total_prospects: z.number(),
        aggregate_base_capacity: z.string(),
        base_capacity_by_engagement: z.record(z.string(), z.string()),
        cross_tab: CrossTabSchema,
        rates: z.record(z.string(), z.number()),
    })
    .transform(
        ({
            total_prospects,
            aggregate_base_capacity,
            base_capacity_by_engagement,
            cross_tab,
            rates,
        }) => ({
            totalProspects: total_prospects,
            aggregateBaseCapacity: aggregate_base_capacity,
            baseCapacityByEngagement: base_capacity_by_engagement,
            crossTab: cross_tab,
            rates,
        }),
    )

export type SummaryStatsData = z.infer<typeof SummaryStatsDataSchema>
